import { Routes } from '@angular/router';

export const publicRoutes: Routes = [
  {
    data: { key: 'quote-decision' },
    loadComponent: () => import('./quotes/quote-decision/quote-decision.page').then((m) => m.QuoteDecisionPage),
    path: 'quotes/:quotePublicId',
  },
  {
    data: { key: 'quote-decision' },
    loadComponent: () => import('./quotes/quote-decision/quote-decision.page').then((m) => m.QuoteDecisionPage),
    path: '**',
  },
];
